import $ from 'jquery';

const playButton = document.querySelector('.play-button');
const pauseButton = document.querySelector('.pause-button');

function displayPlayButton() {
  if (playButton) {
    if (playButton.classList.contains('d-none')) {
      playButton.classList.remove('d-none');
    }
  }
}

function hidePlayButton() {
  if (playButton) {
    if (!playButton.classList.contains('d-none')) {
      playButton.classList.add('d-none');
    }
  }
}

function displayPauseButton() {
  if (pauseButton) {
    if (pauseButton.classList.contains('d-none')) {
      pauseButton.classList.remove('d-none');
    }
  }
}

function hidePauseButton() {
  if (pauseButton) {
    if (!pauseButton.classList.contains('d-none')) {
      pauseButton.classList.add('d-none');
    }
  }
}

function playVideo(isPlayVideo) {
  const bannerImgElement = document.querySelector('.product-video-slot');
  const videoWrapper = document.querySelector('.primary-images__video-wrapper');
  const videoEle = document.getElementById('product-video');
  const imageCarousel = document.querySelector('.primary-images__carousel');
  const container = document.querySelector('.primary-images__wrapper');
  const imageElement = document.querySelector('.primary-images__image-wrapper__inner');
  const videoElement = document.querySelector('.primary-images__video-wrapper__inner');
  let options;

  if (videoEle) {
    if (isPlayVideo === 'true') {
      if (bannerImgElement) {
        bannerImgElement.classList.add('d-none');
      }
      videoEle.classList.remove('d-none');
      hidePlayButton();
    }
    if (imageCarousel.classList.contains('carousel')) {
      options = {
        id: videoEle.dataset.videoid,
        autoplay: videoWrapper.dataset.autoplayvideo === 'true',
        width: imageElement.offsetWidth,
        height: imageElement.offsetHeight,
        muted: true,
        controls: false,
        loop: container.dataset.playvideoinloop === 'true',
        autopause: true,
        responsive: true,
      };
    } else {
      options = {
        id: videoEle.dataset.videoid,
        autoplay: videoWrapper.dataset.autoplayvideo === 'true',
        width: videoElement.offsetWidth,
        height: videoElement.offsetHeight,
        muted: true,
        controls: false,
        loop: container.dataset.playvideoinloop === 'true',
        autopause: true,
        responsive: true,
      };
    }
    // eslint-disable-next-line no-undef
    const videoPlayer = new Vimeo.Player(videoEle, options);
    if (imageCarousel.classList.contains('carousel')) {
      if (videoWrapper.classList.contains('active')
      && ((isPlayVideo === 'true')
      && !videoEle.classList.contains('d-none'))) {
        hidePlayButton();
        hidePauseButton();
        videoPlayer.play();
      } else {
        displayPlayButton();
        hidePauseButton();
        videoPlayer.pause();
      }
    } else if (((isPlayVideo === 'true') && !videoEle.classList.contains('d-none'))) {
      hidePlayButton();
      hidePauseButton();
      videoPlayer.play();
    } else {
      displayPlayButton();
      hidePauseButton();
      videoPlayer.pause();
    }

    videoPlayer.on('ended', () => {
      displayPlayButton();
      hidePauseButton();
    });
    return videoPlayer;
  }
  return null;
}

export default () => {
  const videoWrapper = document.querySelector('.primary-images__video-wrapper');
  const carouselControlNext = document.querySelector('.primary-images__carousel .carousel-control-next');
  const carouselControlPrev = document.querySelector('.primary-images__carousel .carousel-control-prev');
  let thumbPlayBtn = document.querySelector('.pdp-video-thumb-playButton');
  const videoEle = document.getElementById('product-video');
  const thumbImgs = document.querySelectorAll('.lg-thumb-item');
  const imageCarousel = document.querySelector('.primary-images__carousel');
  let touchstartY = 0;
  let touchendY = 0;

  if ((thumbImgs.length > 0) && videoWrapper && videoEle) {
    if (!thumbPlayBtn) {
      const videoSlot = +videoWrapper.dataset.videoslot;
      const thumbBtn = document.createElement('img');
      thumbBtn.classList.add('pdp-video-thumb-playButton');
      thumbBtn.src = videoWrapper.dataset.thumbBtnSrc;
      thumbBtn.dataset.lgItemId = videoWrapper.dataset.videoslot;
      thumbImgs[videoSlot].appendChild(thumbBtn);
      thumbPlayBtn = thumbBtn;
    }
  }
  if (videoWrapper) {
    let player;
    $(carouselControlNext).on('click', () => {
      setTimeout(() => {
        player = playVideo(videoWrapper.dataset.autoplayvideo);
      }, 1000);
    });
    $(carouselControlPrev).on('click', () => {
      setTimeout(() => {
        player = playVideo(videoWrapper.dataset.autoplayvideo);
      }, 1000);
    });
    $(playButton).on('click', () => {
      setTimeout(() => {
        player = playVideo('true');
      }, 1000);
    });
    $(pauseButton).on('click', () => {
      player = playVideo('false');
    });
    $(thumbPlayBtn).on('click', () => {
      setTimeout(() => {
        if ($('.lg-video-play-button')) {
          $('.lg-video-play-button').click();
        }
      }, 1500);
    });

    if (videoWrapper.dataset.autoplayvideo) {
      player = playVideo(videoWrapper.dataset.autoplayvideo);
    }
    $(document.querySelector('.primary-images__video-link-button')).on('click', () => {
      setTimeout(() => {
        player = playVideo(videoWrapper.dataset.autoplayvideo);
      }, 1000);
    });

    $(imageCarousel).on('touchstart', (e) => {
      if (imageCarousel.classList.contains('carousel')) {
        if (videoWrapper.classList.contains('active') && !videoEle.classList.contains('d-none')) {
          if (playButton) {
            if (playButton.classList.contains('d-none')) {
              player.getPaused().then((paused) => {
                if (!paused) {
                  displayPauseButton();
                }
              });
            }
          }
        }
      }
      touchstartY = e.changedTouches[0].screenY;
    });
    $(imageCarousel).on('touchend', (e) => {
      touchendY = e.changedTouches[0].screenY;
      if (touchendY !== touchstartY) {
        if (imageCarousel.classList.contains('carousel')) {
          if (!videoWrapper.classList.contains('active') && videoEle.classList.contains('d-none')) {
            setTimeout(() => {
              player = playVideo('false');
            }, 1000);
          } else {
            setTimeout(() => {
              player = playVideo(videoWrapper.dataset.autoplayvideo);
            }, 1000);
          }
        }
      }
    });
  }
};
